import Vue from 'vue';
import axios from 'axios';
import SiteEnv from '../utils/siteEnv';
import Auth from '../utils/auth.js';

let appid = SiteEnv.showWxServerAccountAppid();
let baseInfo = SiteEnv.showSiteBase();

const isWx = /MicroMessenger/i.test(navigator.userAgent);
Vue.mixin({
  methods: {
    async tzShare(options) {
      const {
        title = `${baseInfo.mottoTitle} ${baseInfo.name}`,
        pic = baseInfo.logo,
        summary = `${baseInfo.mottoContent}\n${baseInfo.name}`,
        url = `${location.protocol}//${location.hostname}/`,
      } = options;
      // const ahead = document.querySelector('head');
      document.getElementById('adescription').setAttribute('content', summary);
      document.getElementById('aimage').setAttribute('content', pic);
      document.getElementById('qqname').setAttribute('content', title);
      // ahead.querySelector('title').innerHTML = title;
      const config = {
        title, // 分享标题
        summary, // 分享内容
        pic, // 分享图片
        url, // 分享链接
      };
      if (isWx) {
        const res = await axios.get(
          SiteEnv.showApiPath() +
            `/invite/weixin/share/ticket?appid=${appid}&targetUrl=${
              location.href
            }`
        );
        if (config.url.indexOf('?') !== -1) {
          config.url = `${config.url}&ivt=${res.data.inviteCode}`;
        } else {
          config.url = `${config.url}?ivt=${res.data.inviteCode}`;
        }
        Object.assign(config, {
          WXconfig: {
            swapTitleInWX: true, // 是否标题内容互换（仅朋友圈，因朋友圈内只显示标题）
            appId: res.data.ticketBody.appid, //appId通过微信服务号后台查看
            timestamp: res.data.ticketBody.timestamp, //生成签名的时间戳
            nonceStr: res.data.ticketBody.nonceStr, //生成签名的随机字符串
            signature: res.data.ticketBody.signature,
          },
        });
      }
      window.setShareInfo(config);
    },
  },
  mounted() {
    if (!Auth.loginUser()) return;
    const { meta = {}, customShare } = this.$options;
    if (meta.page) {
      /**
       * 分享参数都是静态的可以通过这个对象进行配置
       * customShare: 分享参数对象
       * customShare.title: 分享的标题
       * customShare.pic: 分享的图片地址
       * customShare.summary: 分享的摘要
       * customShare.url: 分享的页面地址
       */
      if (customShare) {
        customShare().then(config => {
          this.tzShare(config);
        });
      } else {
        this.tzShare({});
      }
    }
  },
});



// WEBPACK FOOTER //
// ./src/mixins/share.js